import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';

//Context
import { useAuth } from '../../../../context/auth';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Components
import CadastroContratadas from './components/CadastroContratadas';
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';

//API
import contratadas_api from '../../../../api/contratadas_api';

//Helpers
import { showMessage } from '../../../../helpers/message';

function Contratadas({ permissoes }) {
    //State para criar diário oficial
    const [cadastro, setCadastro] = useState(false);

    //State para pegar o id da contratada
    const [contratada_id, setContratada_id] = useState(null);

    //State para lista de contratadas
    const [listContratadas, setListContratadas] = useState([])

    const { setLoading } = useAuth();

    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    const loadContradas = () => {
        setLoading(true)
        contratadas_api.getList()
            .then(response => setListContratadas(response.data))
            .catch(e => showMessage("Erro", e?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadContradas();
    }, []);

    //Cabeçalhos da lista de consulta infração
    const headers = [
        { value: "CNPJ", objectValue: "cnpj", align: "left" },
        { value: "Razão Social", objectValue: "razaoSocial", align: "left" },
        { value: "Responsável", objectValue: "nomeResponsavel", align: "left" },
    ];

    const editarContratada = (rowData) => {
        setContratada_id(rowData.id);
    }

    const visualizarContratada = (rowData) => {
        setContratada_id(rowData.id);
    }

    //Ações que a tabela terá
    const actions = [
        ...editavel
            ? [actionsTable.editar(editarContratada)]
            : [actionsTable.visualizar(visualizarContratada)]
    ];

    const handleVoltar = () => {
        setCadastro(false);
        setContratada_id(null);
        loadContradas();
    }

    if (contratada_id || cadastro) {
        return <CadastroContratadas
            id={contratada_id}
            handleVoltar={handleVoltar}
            editavel={editavel}
        />
    }

    return <>
        <div className='d-flex align-items-center justify-content-between mb-4'>
            <h4 className='text-secondary m-0'>Contratadas</h4>
            {editavel &&
                <Button color='success' onClick={() => {
                    setCadastro(true);
                }}>+ Cadastrar
                </Button>
            }
        </div>
        <TabelaListagem
            actions={actions}
            title={"Lista de contratadas"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={listContratadas}
        />
    </>;
}

export default Contratadas;